import { render } from "./Big2ChartsPage.vue?vue&type=template&id=5b484e14&scoped=true"
import script from "./Big2ChartsPage.vue?vue&type=script&lang=js"
export * from "./Big2ChartsPage.vue?vue&type=script&lang=js"

import "./Big2ChartsPage.vue?vue&type=style&index=0&id=5b484e14&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b484e14"]])

export default __exports__